import { Component, Input } from '@angular/core';
import { TableCollectionActionComponent } from '../table-collection-action/table-collection-action.component';
import { OnlyVisibleTableCollectionActionsPipe } from '../../pipes/only-visible-table-collection-actions.pipe';
import { Nillable } from '@web/utils';
import { TableCollectionAction } from '../../models/table-collection-action';
import { TableRowsSelection } from '../../models/table-rows-selection';

@Component({
  selector: 'app-table-collection-actions',
  imports: [
    TableCollectionActionComponent,
    OnlyVisibleTableCollectionActionsPipe,
  ],
  templateUrl: './table-collection-actions.component.html',
  styleUrls: ['./table-collection-actions.component.scss'],
})
export class TableCollectionActionsComponent<Item, Filter, Action> {
  @Input() public selection!: Nillable<TableRowsSelection<Item, Filter>>;
  @Input() public actions!: TableCollectionAction<Item, Filter, Action>[];
}
